"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInactivityModal = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Modal_1 = require("@app/components/layout/Modal");
var ModalContent_1 = require("@app/components/layout/ModalContent");
require("./UserInactivityModal.scss");
var UserInactivityModal = function (props) { return (react_1.default.createElement(Modal_1.Modal, __assign({}, props),
    react_1.default.createElement(ModalContent_1.ModalContent, { title: "User Inactivity", className: "user-inactivity-modal", onCloseClick: props.onClose },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "inactivity-countdown" }, props.secondsRemaining),
            react_1.default.createElement("div", { className: "inactivity-message" },
                (props.isMaxLimit) ?
                    react_1.default.createElement(react_1.default.Fragment, null, "Congratulations, you have reached the max amount of time allowed in Blast. Log out and take a break, you deserve it.")
                    : (props.secondsRemaining && props.secondsRemaining > 0) ?
                        react_1.default.createElement(react_1.default.Fragment, null, "Your session is about to expire due to inactivity.")
                        :
                            react_1.default.createElement(react_1.default.Fragment, null, "Your session has expired."),
                (props.hasActiveTransfers) ?
                    react_1.default.createElement(react_1.default.Fragment, null,
                        "Any transfer in progress will ",
                        react_1.default.createElement("b", null, "continue"),
                        ".") : null),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: classnames_1.default('column', (props.isMaxLimit) ? 'is-4' : 'is-2') }),
                react_1.default.createElement("div", { className: classnames_1.default('column', (props.isMaxLimit) ? 'is-4' : 'is-3') },
                    react_1.default.createElement("button", { type: "button", className: "button is-light is-fullwidth", onClick: props.onDecline }, "Logout")),
                (!props.isMaxLimit) &&
                    react_1.default.createElement("div", { className: "column is-5" },
                        react_1.default.createElement("button", { type: "button", className: "button button-yellow is-fullwidth", onClick: props.onAccept }, "Continue")),
                react_1.default.createElement("div", { className: classnames_1.default('column', (props.isMaxLimit) ? 'is-4' : 'is-2') })))))); };
exports.UserInactivityModal = UserInactivityModal;
